import { useAppDispatch, useAppSelector } from "app/hooks"
import { updateWater, clearUpdateWaterSuccess } from "../waterSlice"
import { IDailyWater } from "../waterSlice.types"
import { useFailed, useSuccess } from "features/notification/hooks"

export const useUpdateWater = (callback?: () => void) => {
  const updateWaterLoading = useAppSelector(
    (state) => state.water.updateWaterLoading,
  )
  const updateWaterSuccess = useAppSelector(
    (state) => state.water.updateWaterSuccess,
  )
  const updateWaterFailed = useAppSelector(
    (state) => state.water.updateWaterFailed,
  )

  const dispatch = useAppDispatch()

  const handleUpdateWater = (payload: IDailyWater) => {
    dispatch(updateWater(payload))
  }

  const handleClearUpdateWaterSuccess = () => {
    dispatch(clearUpdateWaterSuccess())
  }

  useFailed(updateWaterFailed)
  useSuccess(updateWaterSuccess, { message: "" }, () => {
    handleClearUpdateWaterSuccess()
    callback?.()
  })

  return {
    updateWaterLoading,
    handleUpdateWater,
  }
}
